import "../custom-types/assets.d";
import * as React from "react";
import { createGlobalStyle } from "styled-components";
import { UbuntuFontFace } from "../assets/fonts/ubuntu";
import { BLACK } from "../constant/Colors";
import Helmet from "react-helmet";
import favicon from "../assets/images/favicon.png";
import { Partners, PartnersSmall } from "../section/Partners";
import { Footer } from "../section/Footer";
import { Lequipe } from "../section/Lequipe";
import { LeCollectif } from "../section/LeCollectif";
import { Header } from "../components/Header";
import { SvgLeC } from "../assets/images/LeC";
import le_c_logo_baseline from "../assets/images/le-c-collectif-creatif-climat.png";

import {
  ServiceCreation,
  ServiceStrategie,
  ServiceTech,
} from "../section/NosServices";

const GlobalStyle = createGlobalStyle`
  body {
    margin: 0;
    color: ${BLACK};
  }
`;

export default () => (
  <>
    <Helmet
      title="Le C ! - Collectif Créatif Climat"
      link={[{ rel: "icon", href: favicon }]}
      htmlAttributes={{
        lang: "fr",
      }}
      meta={[
        {
          name: "description",
          content:
            "Nous accompagnons les projets engagés pour un monde plus durable et plus juste.",
        },
        { name: "viewport", content: "width=device-width, initial-scale=0.7" },
        { property: "og:url", content: "https://le-c.fr" },
        { property: "og:type", content: "website" },
        { property: "og:title", content: "Le C ! - Collectif Créatif Climat" },
        {
          property: "og:description",
          content:
            "Nous acompagnons les projets engagés pour un monde plus durable et plus juste.",
        },
        {
          property: "og:image",
          content: `https://le-c.fr${le_c_logo_baseline}`,
        },
        { property: "og:locale", content: "FR" },
        { property: "twitter:card", content: "summary_large_image" },
      ]}
    />
    <GlobalStyle />
    <UbuntuFontFace />
    <Header
      logo={<SvgLeC height={120} color="white" />}
      sections={[
        { title: "Expertises", dom: "services" },
        { title: "Équipe", dom: "equipe" },
        { title: "Projets", dom: "partners" },
      ]}
    />
    <LeCollectif />

    <ServiceCreation />

    <ServiceStrategie />

    <ServiceTech />

    <Lequipe />

    <Partners />

    <PartnersSmall />

    <Footer />
  </>
);
